import React, { useEffect, useRef, useState } from "react";
import { Avatar, Menu, Spin, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import gridSvg from "../assets/svg/eye.svg";
import overviewSvg from "../assets/svg/svg13.svg";
import datasetSvg from "../assets/svg/svg14.svg";
import userSvg from "../assets/svg/svg9.svg";
import passwordSvg from "../assets/svg/svg16.svg";
import setupSvg from "../assets/svg/svg22.svg"; 
import { formatImgPath } from "../utils";
import { setOpenKeys } from "../features/global/globalSlice";
import { save } from "../features/save/saveSlice";
import toast from "react-hot-toast";
import { fetchData } from "../features/fetch/fetchSlice"; 
import { clearObj } from "../features/obj/objSlice";

const icons = {
  gridSvg,
  overviewSvg,
  datasetSvg,
  userSvg,
  passwordSvg,
  setupSvg,
};
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
const menuData = [
  {
    dymId: "1",
    dymLink: "dashboard",
    dymLabel: "Overview",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "overviewSvg",
    children: [],
  },
  {
    dymId: "2",
    dymLink: "datasets",
    dymLabel: "Datasets",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "datasetSvg",
    children: [],
  },
{
    dymId: "5",
    dymLink: "setup",
    dymLabel: "Gl Setup",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "setupSvg",
    children: [],
  },
  
  {
    dymId: "3",
    dymLink: "users-list",
    dymLabel: "Users",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "userSvg",
    children: [],
  }, 
  {
    dymId: "4",
    dymLink: "reset-password",
    dymLabel: "My Account",
    mnOwner: "ALL",
    mnParentId: null,
    dymIcon: "passwordSvg",
    children: [],
  }, 
];
export default function SideBarOpen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "auth/counties/getFiltered";
  const { sideMenuCollapsed, menuLoading, openKeys } = useSelector(
    (state) => state.global
  );

  const { userDetails, counties } = useSelector((state) => state.fetch);
  const { user } = useSelector((state) => state.auth);
  const { uploading } = useSelector((state) => state.save);

  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
  }));
  const [selectedOrg, setSelectedOrg] = useState(
    localStorage.getItem("selectedOrg")
  );
  const [selectedCounty, setSelectedCounty] = useState(
    localStorage.getItem("selectedCounty")
  );

  const [imageSrc, setImageSrc] = useState(
    formatImgPath(
      counties?.[0]?.countyIcon == null
        ? "avatar.png"
        : counties?.[0]?.countyIcon
    )
  );
  const [imageSrcCrump, setImageSrcCrump] = useState(
    formatImgPath(
      data?.[0]?.countyIcon == null ? "avatar.png" : data?.[0]?.countyIcon
    )
  );
  const TruncatedTooltip = ({ text }) => {
    const textRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
      const element = textRef.current;
      if (element) {
        const isOverflowing = element?.scrollWidth > element?.clientWidth;
        setIsTruncated(isOverflowing);
      }
    }, [text]);

    return isTruncated ? (
      <Tooltip title={text}>
        <div
          ref={textRef}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {text}
        </div>
      </Tooltip>
    ) : (
      <div
        ref={textRef}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {text}
      </div>
    );
  };

  const generateMenuItems = (menuData) => {
    if (user?.changePassword === true || user?.changePassword === null) {
      return [];
    }
    const mapItems = (items, isChild) => {
      return items?.map((item) => {
        if (item?.isTitle) {
          return {
            key: item?.dymId,
            label: item?.dymLabel,
            type: "group",
          };
        }
        const iconSrc = icons[item?.dymIcon] || gridSvg;
        return getItem(
          item?.dymLabel?.charAt?.(0)?.toUpperCase() + item?.dymLabel?.slice(1),
          item?.dymLink,
          !isChild ? <img src={iconSrc} alt={item?.dymIcon} /> : null,
          item?.children && item?.children?.length > 0
            ? mapItems(item?.children, true)
            : null
        );
      });
    };
    if (!menuData || menuData?.length === 0) {
      return [];
    }

    return mapItems(menuData);
  };
  const items = [
    ...generateMenuItems(menuData),

    {
      type: "divider",
    },
  ];

  const location = useLocation();
  const currentPath = location.pathname;

  const [lastSelectedKey, setLastSelectedKey] = useState(null);

  const handleNavigation = async (e) => {
    setLastSelectedKey(e.key);
    await navigate(e.key);
    await dispatch(clearObj());
  };

  const selectedKeyFromPath = currentPath?.replace("/", "");
  const validKeys = menuData?.map((item) => item?.dymLink);
  const selectedKey = validKeys?.includes(selectedKeyFromPath)
    ? selectedKeyFromPath
    : lastSelectedKey;

  const defaultOpenKeys = items
    .filter((item) => item?.dymLabel === "Dashboard")
    .map((item) => item?.key);

  const defaultSelectedKeys = items
    .filter((item) => item?.dymLabel === "Dashboard")
    .map((item) => item?.key);

  const handleOpenChange = (keys) => {
    const latestOpenKey = keys.length ? keys[keys.length - 1] : "";
    dispatch(setOpenKeys(latestOpenKey ? [latestOpenKey] : []));
  };

  useEffect(() => {}, [sideMenuCollapsed]);

  useEffect(() => {
    if (data?.[0]?.countyIcon !== null) {
      setImageSrc(formatImgPath(data?.[0]?.countyIcon ?? "avatar.png"));
    }
  }, [data?.[0]?.countyIcon]);

  useEffect(() => {
    if (data?.[0]?.countyIcon !== null && selectedCounty) {
      setImageSrcCrump(formatImgPath(data?.[0]?.countyIcon ?? "avatar.png"));
    }
  }, [selectedCounty, data?.[0]?.countyIcon]);

  const handleImageChange = async (e) => {};

  const onFinish = async (fileUrl) => {
    const res = await dispatch(
      save({
        countyId: data?.[0]?.countyId,
        countyIcon: fileUrl,
        url: "auth/counties/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await fetchCountyFilteredData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  async function fetchCountyFilteredData() {
    await dispatch(
      fetchData({
        url: url,
        countyId: data?.[0]?.countyId,
        start: 0,
        limit: null,
      })
    );
  }

  useEffect(() => {
    const handleStorageChange = () => {
      setSelectedOrg(localStorage.getItem("selectedOrg"));
      setSelectedCounty(localStorage.getItem("selectedCounty"));
    };

    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);
  return (
    <div
      style={{
        borderInlineEnd: "1px solid rgba(5, 5, 5, 0.06)",
        position: "fixed",
        top: "50px",
        left: 0,
        height: "calc(100vh - 50px)",
        overflowY: "auto",
        overflowX: "hidden",
        boxShadow: "4px 0px 25px 0px rgba(0, 0, 0, 0.08)",
      }}
      className="lg:flex hidden flex-col max-w-[256px] w-full bg-white pt-[2rem] mr-5 thin-scrollbar"
    >
      {/* <div className="flex flex-col ml-[1.69rem]">
        <span> <img src={nakuruLogo} alt="nakuruLogo" className="h-[5.06644rem] object-contain"/></span> 
        <span className="text-[#424242] font-appleAlt font-[400] text-[1rem] mt-[.56rem]">
          Nakuru Water and Sanitation Services{" "}
        </span>
      </div> */}

      {items?.length > 0 ? (
        <Menu
          onClick={handleNavigation}
          style={{
            width: 256,
          }}
          className=""
          selectedKeys={selectedKey ? [selectedKey] : []}
          // defaultSelectedKeys={defaultSelectedKeys}
          defaultOpenKeys={defaultOpenKeys}
          mode="inline"
          items={items}
          theme="dark"
          inlineCollapsed={sideMenuCollapsed}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}
